export default "__VITE_ASSET__oL2GjLvk__"